import {
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESSFUL,
  RESET_PASSWORD_FAILED,
} from "./actionTypes"

const initialState = {
  resetPasswordError: null,
  message: null,
  loading: false,
  user: null,
}

const resetPassword = (state = initialState, action) => {
  switch (action.type) {
    case RESET_PASSWORD:
      state = {
        ...state,
        loading: true,
       resetPasswordError: null,
      }
      break
    case RESET_PASSWORD_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        user: action.payload,
       resetPasswordError: null,
      }
      break
    case RESET_PASSWORD_FAILED:
     
      state = {
        ...state,
        user: null,
        loading: false,
       resetPasswordError: action.payload,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default resetPassword
